import axios from 'axios';
const url = process.env.REACT_APP_SPORTS_API_URL;


export async function getTeamInfo(teamId) {
    return axios({
        method: 'get',
        url: url + "/lookupteam.php?id=" + teamId
        //url: "http://localhost:8000/api/events"
    }).then(res => {
        return res.data;
    });
}

export async function getTeamPlayers(teamId) {
    return axios({
        method: 'get',
        url: url + "/lookup_all_players.php?id=" + teamId
        //url: "http://localhost:8000/api/events"
    }).then(res => {
        return res.data;
    });
}


// WEBPACK FOOTER //
// ./src/api-calls/sportsDbApi.js